// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"89a4664c","479":"9943427c","849":"ce9b9b16","881":"174ed3e9"}[chunkId] + ".chunk.css";
};